import script from "./ASManage.vue?vue&type=script&setup=true&lang=js"
export * from "./ASManage.vue?vue&type=script&setup=true&lang=js"

import "./ASManage.vue?vue&type=style&index=0&id=71a0d9ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71a0d9ea"]])

export default __exports__